import React from 'react'
import { useSelector } from 'react-redux'
import s from './GeoentitySuggestChange.less'
import { selectGeoentityPjId } from '../../store/geoentity/geoentity.selectors'

export default function GeoentitySuggestChange() {
  const pjId = useSelector(selectGeoentityPjId)

  if (!pjId) return null

  return (
    <div className={s.content}>
      <p className={s.description}>
        {`Position sur la carte, horaires, adresse, téléphone...`}
        <br />
        <a
          href={`https://www.pagesjaunes.fr/pros/cqfd?epj=${pjId}`}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className={s.link}
        >
          Modifier les infos sur PagesJaunes et Mappy
        </a>
      </p>
    </div>
  )
}
